declare var $: any;

export default class DatePicker {
  public static readonly IS_TOUCH_DEVICE = window.matchMedia('( pointer: coarse )').matches;

  private isInitialized: boolean = false;
  private selector: string;
  private picker: any;

  constructor(selector: string) {
    this.selector = selector;

    if (!DatePicker.IS_TOUCH_DEVICE && window.innerWidth >= 992) {
      this.initialize();
    }

    window.addEventListener('resize', () => this.onWindowResize());
  }

  private onWindowResize(): void {
    if (DatePicker.IS_TOUCH_DEVICE) {
      return;
    }

    if (window.innerWidth < 992 && this.isInitialized) {
      this.isInitialized = false;

      this.picker.attr('type', 'date');
      this.picker.data('daterangepicker').remove();
    }

    if (window.innerWidth >= 992 && !this.isInitialized) {
      this.initialize();
    }
  }

  private initialize(): void {
    this.isInitialized = true;

    this.picker = $(this.selector).daterangepicker({
      singleDatePicker: true,
      autoUpdateInput: false,
      autoApply: true,
      locale: {
        daysOfWeek: [
          'S',
          'M',
          'T',
          'W',
          'T',
          'F',
          'S',
        ],
        monthNames: [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'December',
        ],
      },
      opens: 'right',
    });

    this.picker.attr('type', 'text');

    this.picker.on('apply.daterangepicker', function(ev, picker) {
      $(this).val(picker.startDate.format('DD/MM/YYYY'));
    });
  }
};
